import React from 'react';
import styled from 'styled-components';
import { Button, BUTTON_VARIANTS, type ButtonProps } from '@toqio/toqio-web-components';

/** A DS Button with the `variant` fixed by the wrapper and `size` defaulted. */
export type VariantButtonProps = Omit<ButtonProps, 'variant' | 'size'> & {
  size?: ButtonProps['size'];
};

const variantButton = (variant: ButtonProps['variant'], displayName: string) => {
  // Default `type="button"` so these never accidentally submit a surrounding
  // form (the deleted `Submit` wrapper used to guarantee this); overridable.
  const Component: React.FC<VariantButtonProps> = ({
    size = 'm',
    type = 'button',
    children,
    ...rest
  }) => (
    <Button variant={variant} size={size} type={type} {...rest}>
      {children}
    </Button>
  );
  Component.displayName = displayName;
  return Component;
};

export const PrimaryButton = variantButton(BUTTON_VARIANTS.PRIMARY, 'PrimaryButton');
export const SecondaryButton = variantButton(BUTTON_VARIANTS.SECONDARY, 'SecondaryButton');
export const AccentButton = variantButton(BUTTON_VARIANTS.ACCENT, 'AccentButton');
export const CriticalButton = variantButton(BUTTON_VARIANTS.CRITICAL, 'CriticalButton');

/** Row of buttons; wraps and stacks on narrow viewports. */
export const ButtonsLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
